<template>
  <div class="login columns">
    <div class="login-content column is-one-third">
      <img class="login-logo" src="https://generation-sis-assets.s3.eu-west-1.amazonaws.com/images/genex-logo-02.svg">
      <div class="login-form">
        <form v-on:submit.prevent="login">
          <div class="field">
            <div class="control is-clearfix">
              <input type="email" class="input" placeholder="Email" v-model="email">
            </div>
          </div>
          <div class="field">
            <div class="control is-clearfix">
              <input type="password" class="input" placeholder="Password" v-model="password">
            </div>
          </div>
          <div class="field">
            <div class="control is-clearfix">
              <button class="button">
                <span>Sign In</span>
                <i class="fas fa-caret-right"></i>
              </button>
            </div>
          </div>
          <div class="login-options">
            <div class="login-options-actions">
              <ul>
                <li>
                  <!-- <router-link to="/password/reset">Forgot password</router-link> -->
                </li>
              </ul>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthClient } from "../../clients/AuthClient";
import VueCookie from "vue-cookie";

export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      previousUrl: window.prev
    };
  },
  methods: {
    login() {
      let data = {
        email: this.email,
        password: this.password
      };

      AuthClient.login(data)
        .then(response => {
          VueCookie.set("access_token", response.data.access_token);
          VueCookie.set("refresh_token", response.data.refresh_token);
          window.location = "/";
        })
        .catch(error => {
          console.log(error);

          alert("Login failed. Please check your details");
        });
    }
  }
};
</script>

<style lang='scss' scoped>
.login {
  width: 100%;
}
.login-content {
  margin-left: auto;
  margin-right: auto;
}

.login-logo {
  width: auto;
  height: 10rem;
}
</style>
